import React from 'react';

import { AccordionItem } from '@radix-ui/react-accordion';
import { useTranslation } from 'react-i18next';

import { ReactComponent as InfoIcon } from '@pkg/assets/icons/info-icon.svg';
import { Tooltip } from '@pkg/components/Elements/Tooltip';
import {
    InputFloorPriceRange,
    type InputFloorPriceRangeOnChange,
    type InputFloorPriceRangeValues,
} from '@pkg/components/Sections/Profile/Inputs/InputFloorPriceRange';
import { ReactComponent as EthIcon } from '@pkg/components/Sections/Profile/icons/eth.svg';
import { useTablet } from '@pkg/hooks';

import { FilterContent, FilterHeading } from '../Filter';

import { EthIconWrapper, FloorPriceIconsWrapper } from './styles';

export type FilterCurrencyProps = {
    onChange: (arg: InputFloorPriceRangeOnChange) => void;
    initialState?: InputFloorPriceRangeValues;
    index: string;
    isWide?: boolean;
};

export const FilterCurrency = ({ index, onChange, initialState, isWide }: FilterCurrencyProps) => {
    const { t } = useTranslation(['yat_nft_manager']);
    const isTablet = useTablet();
    const title = t('yat_nft_manager_filter_floor_price');

    return (
        <AccordionItem value={index} disabled>
            <FilterHeading disableUpperCase>
                {title}
                <FloorPriceIconsWrapper>
                    <EthIconWrapper>
                        (<EthIcon />)
                    </EthIconWrapper>
                    <Tooltip trigger={<InfoIcon />} placement={isTablet ? 'bottom-start' : 'bottom-end'}>
                        {t('yat_nft_manager_filter_floor_price_tooltip')}
                    </Tooltip>
                </FloorPriceIconsWrapper>
            </FilterHeading>
            <FilterContent>
                <InputFloorPriceRange isWide={isWide} onChange={onChange} initialState={initialState} />
            </FilterContent>
        </AccordionItem>
    );
};
